export const HEAT_INPUT_DISPLAY_NAME = 'Heat Input';

export const isHeatInputEnergyUnit = (unit: string): boolean =>
  /^kJ\/(in|cm|mm)$/.test(unit);

export const formatHeatInputLabel = (unitSuffix: string): string =>
  `${HEAT_INPUT_DISPLAY_NAME} (${unitSuffix})`;

export const formatHeatInputRangeLabel = (unitSuffix: string): string =>
  `${HEAT_INPUT_DISPLAY_NAME} Range (${unitSuffix})`;

export const isWeldingHeatParameterName = (parameterName: string): boolean => {
  const normalized = parameterName.trim().toLowerCase();
  // Match legacy "Heat" / "Heat (kJ/in)" and display "Heat Input" / "Heat Input (kJ/mm)".
  // Do not match unrelated names like "Heat Number".
  return (
    normalized === 'heat' ||
    normalized.startsWith('heat (') ||
    normalized === 'heat input' ||
    normalized.startsWith('heat input (')
  );
};

export const formatStatusConfigHeatLabel = (
  parameterName: string,
  unit: string
): string | null => {
  if (!isWeldingHeatParameterName(parameterName)) return null;
  return formatHeatInputLabel(unit);
};
